import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import useSWR from 'swr';
import { Modal } from '@shared/components/modals/Modal';
import { ModalWrapper } from '@styles/StyledDiv';
import { requestInactivateLenderCard } from '../LenderUtility/requests';
import { ILenderUtility } from '../LenderUtility/interfaces';
import { requestUpdateGeneral } from '../LenderUtility/tabs/requests';
import { ILenderListItem } from './LenderControlsHeader';

interface IInactivateProps {
  lenderListItem: ILenderListItem;
  openInactivateAlert: boolean;
  setOpenInactivateAlert: React.Dispatch<React.SetStateAction<boolean>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
  updateOptions: (lenderId: string) => void;
}

export const InactivateLenderCardModal = ({
  lenderListItem,
  openInactivateAlert,
  setOpenInactivateAlert,
  setLoading,
  setIsActive,
  updateOptions,
}: IInactivateProps) => {
  const { data: lenderUtility, mutate } = useSWR<ILenderUtility>(() => `/lender-service/lenders/${lenderListItem.id}`);

  const onConfirmInactivate = useCallback(async () => {
    setLoading(true);
    setOpenInactivateAlert(false);
    const resp = await requestInactivateLenderCard(lenderListItem) as { status: number } | null | undefined;
    if (resp && (resp.status === 200 || resp.status === 204)) {
      setIsActive(false);
      updateOptions(lenderListItem.id);
      if (lenderUtility) {
        await requestUpdateGeneral(lenderUtility);
      }
      mutate();
    }
    setLoading(false);
  }, [lenderListItem, setIsActive, setLoading, setOpenInactivateAlert, updateOptions]);


  return (
    <Modal
      showFooter
      cancelButtonText="No"
      buttonText="Yes"
      isLoading={false}
      open={openInactivateAlert}
      dialogMinWidth="986px"
      onConfirm={onConfirmInactivate}
      onClose={() => setOpenInactivateAlert(false)}
    >
      <ModalWrapper>
        <Typography variant="h3" mb={2}>Would you like to inactivate {lenderListItem.name}'s rate card?</Typography>
      </ModalWrapper>
    </Modal>
  );
};